<template lang="pug">
  div
    router-view
</template>

<script>
export default {
  name: 'Information',
  beforeRouteLeave (to, from, next) {
    // sessionStorageを初期化する
    this.resetSession()
    // 一覧検索条件を初期化する
    this.$store.commit('initListConds')

    next()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/announcement/Index.vue